const TurnkeyWalletConnectorInfo = {
    Turnkey: {
        key: 'turnkey',
        name: 'Turnkey',
    },
    TurnkeyHD: {
        key: 'turnkeyhd',
        name: 'Turnkey HD',
    },
};

export { TurnkeyWalletConnectorInfo };
